import "./App.css";
import React, { useState, useEffect, useReducer, useRef } from "react";
import RouterWrapper from "./components/Router/Router";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation, useNavigate } from "react-router-dom";
import TimeoutModal from "./TimeOutModal";
import packageJson from "./../package.json";
import { handlingCatchError } from "./Utils/ErrorHandling";
import {
  IconButton,
  Snackbar,
  Alert,
  Modal,
  Paper,
  Typography,
  Button,
} from "@mui/material";
import { HubConnectionBuilder } from "@microsoft/signalr";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import { apiCommonTrigger } from "./Utils/apiServicehelper";
import { Config } from "./Utils/Config";
import { useDispatch } from "react-redux";
import SessionConflictModal from "./SessionConflictModal";
import { triggerLogOut } from "./Utils/utils";
import ConstantData from "./Utils/Constant";
import { useSelector } from "react-redux";
global.appVersion = packageJson.version;

const SnackBar = (props) => {
  const { open, message, handle, severity } = props;
  let isAdmin = window.globalThis.REACT_SNACK_MESSAGE === "admin";

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      id={"snackClr"}
      className={
        "snackbar bg-color-primary snackbar_admin_alert custom-snackbar" +
        (isAdmin ? " admin-alter-info" : "")
      }
       autoHideDuration={window.globalThis.REACT_SNACK_AUTO_HIDE === false ? null : 3000}
      onClose={() =>{handle(window.globalThis.REACT_SNACK_AUTO_HIDE ? false : true)}}
      ContentProps={{
        "aria-describedby": "message-id",
      }}
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={() => handle(false)}
        >
          <CloseIcon />
        </IconButton>,
      ]}
    >
      <Alert
        onClose={() => handle(false)}
        severity={severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        <span id="message-id">
          {isAdmin && <WarningIcon />}
          {message}
        </span>
      </Alert>
    </Snackbar>
  );
};

function App() {
  let connection = null;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isDeniedRef = useRef(false);
  const isFrom =
    location.pathname === "/market-data" || location.pathname === "/"
      ? true
      : false;
  const [priceData, setPriceData] = useState([]);
  const [priceWholeData, setPriceWholeData] = useState([]);
  const [isAuthenticated, setAuth] = useState(false);
  const [snackBar, setSnackBar] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("info");
  const [timer, setTimer] = useState(null);
  const [isClick,setIsClick] = useState(false)
  const [isWarningSnackbarOpen, setIsWarningSnackbarOpen] = useState(false);

  const userData = JSON.parse(localStorage.getItem("user") || "null");
  const isDemoMarket=useSelector((state)=>state.isDemomarket);
  useEffect(() => {
    if (
      localStorage.getItem("accessKey") &&
      localStorage.getItem("accessKey") !== undefined &&
      localStorage.getItem("accessKey") !== "undefined"
    ) {
      setAuth(true);
    }
  }, [localStorage.getItem("accessKey")]);

  useEffect(() => {
    window.addEventListener("storage", handleStorageEvent);
    initializeSignalr();
    return () => {
      // Clean up the SignalR connection
      if (connection) {
        connection
          .stop()
          .catch((err) =>
            console.error("Error stopping SignalR connection:", err)
          );
      }
      window.removeEventListener("storage", handleStorageEvent);
    };
  }, []);

  // Storing price detials here
  useEffect(() => {
    const fetchData = async () => {
      await apiCommonTrigger("get" , Config.API_URL + "/home/pricedetails")
        .then((res) => {
          if (res.status === 200) {
            const collectionOfData = res.data;
            setPriceData({
              ...priceData,
              Single_Market_Price: collectionOfData.filter(data=>data.id === ConstantData.lookupKeyMap.singleReport)[0].price,
              ProSubscriptionPrice: Math.floor(collectionOfData.filter(data=>data.id === ConstantData.lookupKeyMap.annually)[0].price / 12),
              QuarterlySubscriptionPrice: Math.floor(collectionOfData.filter(data=>data.id === ConstantData.lookupKeyMap.quarterly)[0].price / 3),
              Period: "Month",
              Currency: collectionOfData[1].currency,
              LookupKey: collectionOfData.filter(data=>data.id === ConstantData.lookupKeyMap.singleReport)[0].lookupkey,
              ProLookupKey: collectionOfData.filter(data=>data.id === ConstantData.lookupKeyMap.annually)[0].lookupkey,
              QuartLookupKey: collectionOfData.filter(data=>data.id === ConstantData.lookupKeyMap.quarterly)[0].lookupkey
            });
            localStorage.setItem(
              "Single_Market_Price",
              collectionOfData.filter(data=>data.id === ConstantData.lookupKeyMap.singleReport)[0].price
            );
            localStorage.setItem("Currency", collectionOfData[1].currency);
            setPriceWholeData(res.data);
          } else {
            // setLoading(false);
            handlingCatchError(res, navigate);
          }
        })
        .catch((error) => {
          // setLoading(false);
          handlingCatchError(error, navigate);
        });
    };
    fetchData();
  }, []);

  const initializeSignalr = async () => {
    const UrlValue = `${Config.API_URL}/notificationHub`;
    connection = new HubConnectionBuilder()
      .withUrl(UrlValue, {
        withCredentials: true, // Ensures credentials are sent (cookies, auth headers, etc.)
      })
      .build();

    try {
      await connection.start();
      console.log("SignalR connection state:", connection.state);
    } catch (error) {
      console.log("SignalR Error", error);
    }
    // Should be 'Connected' if successful

    connection.on("ReceiveMessage", (triggerObj) => {
      const user = localStorage.getItem("user");
      const userData =
        user && typeof user === "string" ? JSON.parse(user) : user;
      const secureIdList = triggerObj?.firstsession?.split(",");
      if (secureIdList.includes(userData?.secureid)) {
        setTimer(ConstantData.otpSettings.sessionWaitingSec);
        setIsWarningSnackbarOpen(true);
      }
    });
  };

  const logOut = () => {
    setAuth(!isAuthenticated);
    localStorage.removeItem("user");
    localStorage.clear();
    navigate("/");
  };

  const handleSnackbar = (value) => {
    if (window.globalThis.REACT_SNACK_MESSAGE === "admin") {
      setSnackBar(value);
      setSnackMessage(
        value
          ? `You are logged in as "${localStorage.getItem("getNames")}"`
          : ""
      );
    } else if (value && window.globalThis.REACT_SNACK_OPEN) {
      let message = window.globalThis.REACT_SNACK_MESSAGE;
      let severity = window.globalThis.REACT_SNACK_SEVERITY || "info";

      setSnackBar(value);
      setSnackMessage(value && message ? message : "");
      setSnackSeverity(severity);
    } else {
      window.globalThis.REACT_SNACK_OPEN = value;
      window.globalThis.REACT_SNACK_MESSAGE = "";
      window.globalThis.REACT_SNACK_SEVERITY = "info";
      setSnackBar(value);
      setSnackMessage("");
    }
  };
  // Start a countdown timer for resend OTP after 75 seconds
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsWarningSnackbarOpen(false);
      if(!isClick){
        logOut();
      }
      if (interval) {
        clearInterval(interval); // Clean up the interval
      }
    }
   return(()=>{
        clearInterval(interval); // Clean up the interval
   })
  }, [timer]);

  const handleCloseWarningSnackbar = () => {
    setIsWarningSnackbarOpen(false);
  };

  const handleStorageEvent = (event) => {
    if (event.key === "is2faClicked" && event.newValue) {
      const data = JSON.parse(event.newValue);
      if (data) window.location.reload();
    }
  };

  const handleClickAllow = () => {
    setIsClick(true);
    setIsWarningSnackbarOpen(false);
    const timerData = JSON.stringify({ timer: timer });
    // Use Cache API to store the timer data
    caches.open("timer-cache").then((cache) => {
      const response = new Response(timerData, {
        status: 200,
        statusText: "OK",
      });
      cache.put("timerState", response);
      dispatch({ type: "isShowTimer", value: true });
    });
    apiCommonTrigger("get",`${Config.API_URL}/AuthToken/session/allow`)
  .then(() => {
      localStorage.setItem(
        "is2faClicked",
        JSON.stringify({ type: "isDenied", timestamp: Date.now() })
      );
    })
     .catch((error) => {  
          handlingCatchError(error);
        });
    setIsWarningSnackbarOpen(false);
  };

  const handleClickDeny = () => {
    setIsClick(true);
      apiCommonTrigger("get",`${Config.API_URL}/AuthToken/session/deny`)
   .then(() => {
      handleCloseWarningSnackbar();
      localStorage.setItem(
        "is2faClicked",
        JSON.stringify({ type: "isDenied", timestamp: Date.now() })
      );
    })
    .catch((error) => {  
        handlingCatchError(error);
      })
  };


  var userDetails = localStorage.getItem('user') !== null ? localStorage.getItem('user') : null;  
  const user = JSON.parse(userDetails || "{}");
  const isFreeUser = (user.usertype || "") === "Free";
  var username = userDetails !== null && JSON.parse(userDetails).username !== null ? JSON.parse(userDetails).username : "";
  return (
    <div className={`App ${isFrom ? "is-marketdata" : ""} ${isFreeUser&&isDemoMarket ? "blackoverlay" : ""}`}>
      <div id="enable-error-snack" onClick={() => handleSnackbar(true)}></div>

      <RouterWrapper packageInfo={priceData} packageFullData={priceWholeData} />

      <TimeoutModal isAuthenticated={isAuthenticated} logOut={logOut} />
      <SnackBar
        {...{
          open: snackBar,
          message: snackMessage,
          handle: handleSnackbar,
          severity: snackSeverity,
        }}
      />
      <SessionConflictModal
        isWarningSnackbarOpen={isWarningSnackbarOpen}
        timer={timer}
        handleCloseWarningSnackbar={handleCloseWarningSnackbar}
        logOut={logOut}
        handleClickAllow={handleClickAllow}
        handleClickDeny={handleClickDeny}
      />
    </div>
  );
}

export default App;
